export default class Constant {
    public static MaxMobileWidth: number = 1279;
}